// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5b5fb989","972":"c0b747a9"}[chunkId] + ".chunk.js";
};